import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import demppic from "../../assets/image/user-circle.svg"
import Loader from '../../Components/Loader/Loader';

function TotalSessionMonth() {
   
   
      const [totalPages, setTotalPages] = useState(0)
      const [total, setTotal] = useState(0)
      const [page, setPage] = useState(1);
      const [perPage, setPerPage] = useState(10);
      const [indexNumber, setIndexNumber] = useState(0)
     
      const [id, setId] = useState(0);
      const [user, setUser] = useState([]);
   
      const [block, setBlock] = useState(false);
      const blockClose = () => setBlock(false);
      const [delet, setDelet] = useState(false);
      const deleteClose = () => setDelet(false);
      const location = useLocation()
      const [search, setSearch] = useState("");

 
      const navigate = useNavigate();
      useEffect(() => {
          getUserList()
      }, [])
      const paginationHandler = (e, i) => {
          e.preventDefault();
          console.log("iiii", i);
          if (i != page) {
              setPage(i);
              const newIndexNumber = perPage * (i - 1); // Calculate starting index for the page
              setIndexNumber(newIndexNumber);
              // CcrApiList({
              //     ...searchQuery,
              //     page: i,
              //     limit: perPage
              // })
          }
      };
      const getUserList = async () => {
          const response = await handleApiCall("get", `${endpoint.totalsessionList}?page=${page}&limit=${perPage}&id=${location?.state?.coach?._id}${location?.state?.filter}`, {});
          try {
            console.log(response,"Dataaa")
              if (response?.data?.code === 200) {
                  setUser(response?.data?.data?.scheduleSessionList);
  
                  setTotalPages(response?.data?.data?.total_pages);
                  setTotal(response?.data?.data?.total);
              }
              if (response?.response?.data?.success === false) {
               
                toast.error(response?.response?.data?.errorMessage);
                setTimeout(() => { navigate("/") }, 2000);
            }
          } catch (e) {
              console.log("Error fetching data:", e);
          }
      };
    
      const goBack = () => {
          navigate(-1); // Navigates back to the previous page
  
      };
      function getFormattedDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        return `${day} ${month}`; // ➜ "03 May"
      }
      function getFormattedTime(dateString) {
        const date = new Date(dateString);
        const options = { hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleTimeString('en-US', options);
      }
     
    return (
        <>
       
        <div className=' imagebox image flex gap-5'>
                <div className=' flex gap-2 items-center'>
                    <img src={location?.state?.coach?.image || demppic} alt="user" className="w-16 h-16 rounded-full" />
                    <div className=' flex-col'>
                        <p className=' font-bold '>  {location?.state?.coach?.full_name} </p>

                    </div>
                </div>


            </div>
            <div className="common-table-wrapper m-0 ">

                <div className=" my-3">
                    <div className='flex-col gap-2 justify-start items-center'>
                        <h2 className=' mr-5 text-[30px]'>{""}</h2>
                      
                    </div>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-8 sm:grid-cols-3 gap-3 my-2 ">

                   
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Region</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.region_name|| "-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Country</span>
                        <span className="font-bold text-lg text-wrap ">{ location?.state?.coach?.country_name||"-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">State</span>
                        <span className="font-bold text-lg text-wrap ">{ location?.state?.coach?.state_name||"-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Dstrict</span>
                        <span className="font-bold text-lg text-wrap ">{ location?.state?.coach?.district_name||"-"}</span>
                    </div>
                    <div className="border rounded-2 d-flex flex-column   py-2 px-2 bg-[#FFCC4E] bg-opacity-40">
                        <span className=" font-bold text-sm  text-gray-500 text-wrap ">Block</span>
                        <span className="font-bold text-lg text-wrap ">{location?.state?.coach?.block_name||"-"}</span>
                    </div>
                   
                </div>
                <div className=' flex  justify-between my-3 mt-5'>
                    <Link onClick={goBack} className="text-white bg-black hover:text-white outline-1 outline-double rounded-md text-sm font-semibold px-4 py-2 d-inline-block">Back</Link>

                </div>
                <div className="common-table-wrapper m-0">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Teacher name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Gender</th>
                                    <th>School name</th>
                                    <th>Location</th>
                                    <th>Date</th>
                                    <th className=' text-center'>Time</th>

                                </tr>
                            </thead>
                            <tbody>
                                {user?.length > 0 ? (
                                    user.map((item, i) => (
                                        <tr key={item?._id || i}>
                                            <td>{indexNumber + i + 1}</td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <div style={{ width: '35px', height: '35px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                                                        <img
                                                            src={item?.teacher_image || demppic}
                                                            alt={item?.teacher_full_name || 'Profile'}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                    </div>
                                                    {item?.teacher_full_name || "-"}
                                                </div>
                                            </td>
                                            <td>{item?.teacher_email || "-"}</td>
                                            <td>{item?.teacher_phone || "-"}</td>
                                            <td>{item?.teacher_gender || "-"}</td>
                                            <td>{item?.school_name || "-"}</td>
                                            <td>{item?.school_address || "-"}</td>
                                            <td>{getFormattedDate(item?.schedule_date_time) || "-"}</td>
                                            <td>{getFormattedTime(item?.schedule_date_time)|| "-"}</td>
                                         
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="15" className="text-center py-4 text-lg font-semibold">
                                            No teacher available
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>

                    <Row className=" px-2 mb-4 py-2">
                        <Col md={12}>
                            <Pagination
                                data={user}
                                indexNumber={indexNumber}
                                totalPage={totalPages}
                                setPage={setPage}
                                page={page}
                                paginationHandler={paginationHandler}
                                total={total}
                            />
                        </Col>
                    </Row>
                </div>
               
            </div>

        </>
    )
}

export default TotalSessionMonth